import { render, staticRenderFns } from "./ev5-usp-swiper.vue?vue&type=template&id=f30bdbf6&scoped=true"
import script from "./ev5-usp-swiper.vue?vue&type=script&lang=js"
export * from "./ev5-usp-swiper.vue?vue&type=script&lang=js"
import style0 from "./ev5-usp-swiper.vue?vue&type=style&index=0&id=f30bdbf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30bdbf6",
  null
  
)

export default component.exports